import { currentUserShowSuccess } from '../../ducks/user.duck';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { normalizeUrl } from '../../util/urls';

// Company links (Länkar) are stored on the seller's own profile publicData —
// mirroring the Tillval/Tjänster tab (sdk.currentUser.updateProfile). No
// separate backend/collection. The company profile page reads `website`;
// `bookingUrl` is consumed server-side at checkout (booking link in the order
// confirmation); `googleBusinessUrl` is admin-facing input for the Google
// reviews badge verification flow.

// ================ Action types ================ //

export const SAVE_LINKS_REQUEST = 'app/ManageLinksPage/SAVE_LINKS_REQUEST';
export const SAVE_LINKS_SUCCESS = 'app/ManageLinksPage/SAVE_LINKS_SUCCESS';
export const SAVE_LINKS_ERROR = 'app/ManageLinksPage/SAVE_LINKS_ERROR';

// ================ Reducer ================ //

const initialState = {
  saveInProgress: false,
  saveError: null,
  saveSuccess: false,
};

const manageLinksPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SAVE_LINKS_REQUEST:
      return { ...state, saveInProgress: true, saveError: null, saveSuccess: false };
    case SAVE_LINKS_SUCCESS:
      return { ...state, saveInProgress: false, saveSuccess: true };
    case SAVE_LINKS_ERROR:
      return { ...state, saveInProgress: false, saveError: payload };
    default:
      return state;
  }
};

export default manageLinksPageReducer;

// ================ Action creators ================ //

export const saveLinksRequest = () => ({ type: SAVE_LINKS_REQUEST });
export const saveLinksSuccess = () => ({ type: SAVE_LINKS_SUCCESS });
export const saveLinksError = error => ({ type: SAVE_LINKS_ERROR, payload: error });

// ================ Thunks ================ //

// Persist the three links onto the current user's profile publicData. Each
// value is normalized (trimmed, https:// prepended for a bare domain) and an
// empty field is stored as null so it clears any previous value.
export const saveLinks = ({ website, googleBusinessUrl, bookingUrl }) => (dispatch, getState, sdk) => {
  dispatch(saveLinksRequest());
  const links = {
    website: normalizeUrl(website) || null,
    googleBusinessUrl: normalizeUrl(googleBusinessUrl) || null,
    bookingUrl: normalizeUrl(bookingUrl) || null,
  };
  return sdk.currentUser
    .updateProfile({ publicData: { links } }, { expand: true })
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length === 1) {
        dispatch(currentUserShowSuccess(entities[0]));
      }
      dispatch(saveLinksSuccess());
    })
    .catch(e => {
      console.error('Save links failed', e);
      dispatch(saveLinksError(storableError(e)));
    });
};
